import { useMutation } from '@tanstack/react-query';
import { IEditPromoBody } from "../../utils/types";
import { apiManager } from "../api-manager";
import { apiClient } from '../api-manager-instance';

export const editPromo = async ({ id, ...rest }: IEditPromoBody) => {
  const res = await apiManager.patch(`/admin/promoCode/${id}/modify`, {
    ...rest,
  });
  return res;
};


export const useEditPromo = () =>
  useMutation({
    mutationFn: async ({ id, ...rest }: IEditPromoBody) => {
      const res = await apiClient.patch(`/admin/promoCode/${id}/modify`, rest);
      return res.data;
    },
  });
